import { Grid } from '@material-ui/core';
import * as React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

import { Async } from '../../../../components/AsyncProvider';
import { BackButton } from '../../../../components/BackButton';
import { Button } from '../../../../components/Button/index';
import { FileUpload } from '../../../../components/FileUpload/index';
import { Input } from '../../../../components/Input';
import { Loading } from '../../../../components/Loading/index';
import { SelectInput } from '../../../../components/SelectInput/index';
import { IAsyncData } from '../../../../models';
import { IApplicationState } from '../../../../store/models';
import { useQuery } from '../../../../utils';
import { Container } from '../../../Layout/components/Container/index';
import { setFooterVisibility } from '../../../Layout/store/actions';
import { applyPositionAction, clearApplyPositionBranchAction, getCareers } from '../../store/actions';
import { ICareer } from '../../store/models';

import './index.scss';

export interface IApplyForm extends Record<EFieldName, string> {
    file?: File[];
}

enum EFieldName {
    NAME = 'first_name',
    SURNAME = 'last_name',
    MESSAGE = 'message',
    POSITION = 'vacancy_id',
}

export const Apply: React.FC = () => {
    const dispatch = useDispatch();
    const { register, handleSubmit, setValue } = useForm<IApplyForm>();
    const applyPositionBranch = useSelector<IApplicationState, IAsyncData<void>>((state) => state.careers.apply);
    const handleSubmitForm = (form: IApplyForm) => {
        dispatch(applyPositionAction(form));
    };

    const params = useQuery();

    React.useEffect(
        () => {
            dispatch(setFooterVisibility(false));
            const position = params.get('position');

            if (position) {
                setValue(EFieldName.POSITION, position);
            }

            return () => {
                dispatch(setFooterVisibility(true));
                dispatch(clearApplyPositionBranchAction());
            };
        },
        [dispatch, params, setValue],
    );
    React.useEffect(
        () => {
            dispatch(getCareers());
        },
        [dispatch]
    );
    const careersBranch = useSelector<IApplicationState, IAsyncData<ICareer>>(state => state.careers.vacancies);
    const positions = careersBranch.data && careersBranch.data.vacancies.map((vacancy) => ({
        value: vacancy.id,
        text: vacancy.position,
    }));

    return (
        <section id="apply-position">
            <Container>
                <Grid container justify="center">
                    <Grid item sm={6} xs={12}>
                        <BackButton />
                        <Async
                            branch={applyPositionBranch}
                            deps={[positions]}
                            initialRender={() => (
                                <>
                                    <Input
                                        placeholder="Name"
                                        name={EFieldName.NAME}
                                        register={register({ required: true })}
                                    />
                                    <Input
                                        placeholder="Surname"
                                        name={EFieldName.SURNAME}
                                        register={register({ required: true })}
                                    />
                                    <SelectInput
                                        name={EFieldName.POSITION}
                                        options={positions || []}
                                        register={register({ required: true })}
                                    />
                                    <Input
                                        placeholder="Message"
                                        name={EFieldName.MESSAGE}
                                        register={register({ required: true })}
                                    />
                                    <FileUpload
                                        register={register({ required: true })}
                                    />
                                    <div className="send-message-submit">
                                        <Button onClick={handleSubmit(handleSubmitForm)}>Apply</Button>
                                    </div>
                                </>
                            )}
                            loadingRender={() => <Loading />}
                            successRender={() => (
                                <div className="message">
                                    <h3>Thank You!</h3>
                                </div>
                            )}
                        />
                    </Grid>
                </Grid>
            </Container>
        </section>
    );
};
